module.exports = __webpack_public_path__ + "static/media/instant_switch_logo.35f2304f.png";